import { Outlet } from 'react-router-dom';

interface AuthPageLayoutProps {
  title: string;
  subtitle: string;
  phone: string;
  email: string;
  maxWidth?: string;
}

export const AuthPageLayout = ({
  title,
  subtitle,
  phone,
  email,
  maxWidth = '',
}: AuthPageLayoutProps) => {
  return (
    <div className="w-full">
      <div
        className={`bg-white border-t border-l border-r ${maxWidth} border-gray-200 rounded-t-lg`}
      >
        <div className="p-6 flex flex-col gap-6">
          <div className="flex flex-col gap-1 text-center">
            <p className="text-base font-medium text-gray-500 leading-6">
              {subtitle}
            </p>
            <h1 className="text-xl font-semibold text-gray-900 leading-6">
              {title}
            </h1>
          </div>
          <div className="flex justify-center">
            <Outlet />
          </div>
          <div className="flex justify-between items-center text-base font-medium px-4">
            <span className="text-gray-900">{phone}</span>
            <span className="text-blue-700">{email}</span>
          </div>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-b-lg">
        <div className="px-6 py-4">
          <div className="flex justify-end pr-4">
            <button className="text-base font-medium text-blue-700 leading-6">
              О платформе
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
